// extracted by mini-css-extract-plugin
export default {"versions":"bt_gH","newsletterSignup":"bt_gJ","announcement":"bt_gK"};